import { Space, Typography } from "antd";
import React, { Component } from "react";

class ServicesData extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "start",
          width: this.props.userData.isMobile ? "100%" : "80%",
          flexDirection: "column",
          gap: 8,
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Typography.Title
            level={5}
            style={{
              margin: "10px 0px",
            }}
          >
            Servicios contratados:
          </Typography.Title>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {this.props.userData.products.some(
            (product) => product.type === 2
          ) && (
            <div>
              <Typography style={{ fontWeight: "bold", paddingBottom: 12 }}>
                Internet:
              </Typography>
              <Space
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  flexWrap: "wrap",
                }}
              >
                {this.props.userData.products.map((product) => {
                  if (product.type === 2) {
                    return (
                      <div
                        style={{
                          width: this.props.userData.isMobile ? "100%" : "",
                          border: "1px solid #8d99ae",
                          textAlign: "left",
                          padding: "14px 14px",
                          borderRadius: "6px",
                        }}
                        key={product.id}
                      >
                        <Typography>{`${
                          product.subtype === 22 ? "Fibra:" : "Wifi:"
                        } ${product.label}`}</Typography>
                        <Typography>{`Precio: ${product.price} /mes`}</Typography>
                        <Typography>
                          {product.permanence ? product.permanence.label : ""}
                        </Typography>
                        <Typography>
                          {product.extraFields[0]
                            ? `Dirección: ${product.extraFields[0].value}`
                            : ""}
                        </Typography>
                      </div>
                    );
                  }
                })}
              </Space>
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {this.props.userData.products.some(
            (product) => product.type === 3
          ) && (
            <div>
              <Typography style={{ fontWeight: "bold", paddingBottom: 12 }}>
                ​​​Móvil​:
              </Typography>
              <Space
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  flexWrap: "wrap",
                }}
              >
                {this.props.userData.products.map((product) => {
                  if (product.type === 3) {
                    return (
                      <div
                        key={product.id}
                        style={{
                          width: this.props.userData.isMobile ? "100%" : "",
                          border: "1px solid #8d99ae",
                          textAlign: "left",
                          padding: "14px 14px",
                          borderRadius: "6px",
                        }}
                      >
                        <Typography>{`Pack: ${product.label}`}</Typography>
                        <Typography>{`Precio: ${product.price} /mes`}</Typography>
                        <Typography>{`Linea: ${product.extraFields[0].value}`}</Typography>
                      </div>
                    );
                  }
                })}
              </Space>
            </div>
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
          }}
        >
          {this.props.userData.products.some(
            (product) => product.type === 4
          ) && (
            <div>
              <Typography style={{ fontWeight: "bold", paddingBottom: 12 }}>
                ​​​Otro​:
              </Typography>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 8,
                  flexWrap: "wrap",
                }}
              >
                {this.props.userData.products.map((product) => {
                  if (product.type === 4) {
                    return (
                      <div
                        key={product.id}
                        style={{
                          width: this.props.userData.isMobile ? "100%" : "auto",
                          border: "1px solid #8d99ae",
                          textAlign: "left",
                          padding: "14px 14px",
                          borderRadius: "6px",
                        }}
                      >
                        <Typography>{`Concepto: ${product.label}`}</Typography>
                        <Typography>{`Precio: ${product.price} ${
                          !product.onePayment ? "/mes" : "pago único"
                        }`}</Typography>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ServicesData;



// WEBPACK FOOTER //
// ./src/views/Contract/components/ServicesData.jsx